/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FC, useMemo } from 'react';

import { useQueries } from '@tanstack/react-query';
import dayjs from 'dayjs';

import { formatPara } from './helper';
import { getInsights } from '../../axiosClient/draftApi';
import { RootState, useTypedSelector } from '../../redux/store';

interface IProps {
  sections?: any;
  id?: string;
}

const RenderList: FC<{ sections: any; id?: string }> = ({ id, sections }) => {
  const combinedQueries = useQueries({
    queries:
      sections && id
        ? sections.map((data: any) => {
            return {
              queryKey: ['insights-list', data.id, id],
              queryFn: () => getInsights(id, data.id),
            };
          })
        : [],
    combine: (results) => {
      return {
        data: results.map((result) => {
          const newResult: any = result.data as any[];
          if (newResult) {
            let content1: any[] = [];
            let content2: any[] = [];
            newResult?.q1_content?.map((content: any) => {
              if (content?.answer) {
                content1 = [...content1, ...content.answer.split('\n')];
              }
            });
            newResult?.q2_content?.map((content: any) => {
              if (content?.answer) {
                content2 = [...content2, ...content.answer.split('\n')];
              }
            });
            const shortedContent1 = content1.filter((data) => {
              const para = formatPara(data);
              return (
                para !== '' &&
                para?.toLowerCase() !== 'not found' &&
                para?.toLowerCase() !== 'not found.'
              );
            });
            const shortedContent2 = content2.filter((data) => {
              const para = formatPara(data);
              return (
                para !== '' &&
                para?.toLowerCase() !== 'not found' &&
                para?.toLowerCase() !== 'not found.'
              );
            });
            newResult.insights = [...shortedContent1];
            newResult.issues = [...shortedContent2];
          }
          return newResult;
        }),
        pending: results.some((result) => result.isPending),
      };
    },
  });

  return (
    <td colSpan={2}>
      {!combinedQueries?.pending &&
        combinedQueries?.data?.map((data: any, index) => (
          <table key={index}>
            <thead>
              <tr
                style={{
                  backgroundColor: '#8DB4E2',
                  fontSize: '14px',
                  fontWeight: 'bold',
                  textAlign: 'center',
                }}
              >
                <th>Clause name</th>
                <th>Clause Text</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{data?.clause || ''}</td>
                <td
                  style={{
                    padding: '5px',
                    width: '500px',
                    wordBreak: 'break-word',
                  }}
                >
                  {data?.insights?.map((para: string, index: number) => (
                    <li key={index}>{para}</li>
                  ))}
                </td>
              </tr>
            </tbody>
          </table>
        ))}
    </td>
  );
};

const RenderTableTopInfo: FC<{ tableInfo: any }> = ({ tableInfo }) => {
  return (
    <>
      {tableInfo.map((info: any, index: number) => {
        return (
          <tr key={index}>
            <td
              style={{
                backgroundColor: '#8DB4E2',
                fontSize: '16px',
                fontWeight: 'bold',
                textAlign: 'center',
                color: info.color ? info.color : 'black',
                borderWidth: 1,
                borderColor: 'black',
                borderStyle: 'solid',
              }}
            >
              {info.key}
            </td>
            <td
              colSpan={2}
              style={{
                backgroundColor: '#8DB4E2',
                fontSize: '16px',
                fontWeight: 'bold',
                textAlign: 'center',
                color: info.color ? info.color : 'black',
                borderWidth: 1,
                borderColor: 'black',
                borderStyle: 'solid',
              }}
            >
              {info.value}
            </td>
          </tr>
        );
      })}
    </>
  );
};

const TableExcel = (props: IProps) => {
  const { sections, id } = props;
  const { draft } = useTypedSelector((state: RootState) => state.draft);

  const tableInfo = useMemo(() => {
    const date = new Date().toISOString();
    return [
      {
        key: 'Downloaded On',
        value: `${dayjs(date).format('DD/MM/YYYY, h:mm A')} IST`,
      },
      {
        key: 'Downloaded By:',
        value: localStorage.getItem('user_name') || '',
      },
      { key: 'File Name', value: draft?.name || '' },
    ];
  }, []);

  return (
    <table
      id="table-to-xls-insights"
      style={{ display: 'none', fontFamily: 'Cambria Math' }}
    >
      <thead>
        <RenderTableTopInfo tableInfo={tableInfo} />
        <tr>
          <td colSpan={3}></td>
        </tr>
        <tr>
          <td colSpan={3}></td>
        </tr>
        <tr
          style={{
            backgroundColor: '#8DB4E2',
            fontSize: '14px',
            fontWeight: 'bold',
            textAlign: 'center',
          }}
        >
          <th>Type of Clause</th>
          <th style={{ width: '500px' }}>Clause</th>
        </tr>
      </thead>
      <tbody>
        {Object.entries(sections || {})?.map((section: any, key) => (
          <tr key={key}>
            <td>{section[0]}</td>
            <RenderList id={id} sections={section[1]} />
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default TableExcel;
